import { Injectable } from '@angular/core';
import { CaseRouteBuilderService } from './case-route-builder.service';
import { DriverRouteBuilderService } from './driver-route-builder.service';
import { FinanceRouteBuilderService } from './finance-route-builder.service';
import { HelpDeskRouteBuilderService } from './helpdesk-route-builder.service';
import { ProhibitionComplianceRouteBuilderService } from './prohibition-compliance-route-builder.service';
import { IRouteBuilder } from './route-builder.interface';
import { RouteBuilderService } from './route-builder.service';
import { TitleRegistrationRouteBuilderService } from './title-registration-route-builder.service';
import { CollectionsRouteBuilderService } from './collections-route-builder.service';
import { IRPRouteBuilderService } from './irp-route-builder.service';
import { CommercialPermittingRouteBuilderService } from './commercial-permitting-route-builder.service';
import { AircraftRouteBuilderService } from './aircraft-route-builder.service';

@Injectable()
/**
 * Factory service for getting source system implementation of routing
 */
export class RouteBuilderFactory {

    private services: RouteBuilderService[];

    constructor(
        private titleRegistrationRouteBuilderService: TitleRegistrationRouteBuilderService,
        private driverRouteBuilderService: DriverRouteBuilderService,
        private financeRouteBuilderService: FinanceRouteBuilderService,
        private prohibitionComplianceRouteBuilderService: ProhibitionComplianceRouteBuilderService,
        private helpDeskRouteBuilderService: HelpDeskRouteBuilderService,
        private caseRouteBuilderService: CaseRouteBuilderService,
        private collectionsRouteBuilderService: CollectionsRouteBuilderService,
        private irpRouteBuilderService: IRPRouteBuilderService,
        private commercialPermittingRouteBuilderService: CommercialPermittingRouteBuilderService,
        private aircraftRouteBuilderService: AircraftRouteBuilderService
    ) {
        this.services = [];
        this.services.push(titleRegistrationRouteBuilderService);
        this.services.push(driverRouteBuilderService);
        this.services.push(financeRouteBuilderService);
        this.services.push(prohibitionComplianceRouteBuilderService);
        this.services.push(helpDeskRouteBuilderService);
        this.services.push(caseRouteBuilderService);
        this.services.push(collectionsRouteBuilderService);
        this.services.push(irpRouteBuilderService);
        this.services.push(commercialPermittingRouteBuilderService);
        this.services.push(aircraftRouteBuilderService);
    }

    /**
     * Get the route builder for the specified source system
     */
    public create(sourceSystemTypeId: number): IRouteBuilder {
        return this.services.find(s => s.sourceSystemType.id == sourceSystemTypeId);
    }
}
